<ng-content select="[header]"></ng-content>

<ng-content></ng-content>

<ul role="tablist" aria-orientation="horizontal" [ngClass]="wrapperContainer()">
  @for (tab of tabs; track tab; let i = $index) {
    <li [ngClass]="css()">
      <a
        role="tab"
        [attr.aria-selected]="tab.active"
        [attr.aria-controls]="tab.tabTitle + 'panel'"
        class="text-center nav-link fw-700"
        [ngClass]="tabHeaderCss()"
        [id]="tab.title"
        [class.active]="tab.active"
        (click)="setActiveTab(i)"
        href="javascript:">
        @for (span of tab.additionalSpans; track span) {
          <span [ngClass]="span.class">
            {{ span.innerHtml }}
          </span>
        }
        {{ tab.tabTitle }}
      </a>
    </li>
  }
</ul>

@for (tab of tabs; track tab) {
  <div [hidden]="!tab.active">
    <ng-container *ngTemplateOutlet="tab.template"></ng-container>
  </div>
}
